import {
  StyledTd,
  StyledTh,
  StyledTr,
  GridWrapper,
  StyledTable,
  StyledThead,
  StyledThChild,
  GridInnerWrapper,
  LoadingOverlay,
  StyledTdEmptyData
} from './table.styled'

const renderCell = (col, row, rowIndex) => {
  if (col.customCell) {
    return col.customCell({
      field: col.field,
      width: col.width,
      dataItem: row,
      dataIndex: rowIndex
    })
  }
  return <StyledTd style={{ width: col.width }}>{row[col.field]}</StyledTd>
}

const renderColumns = (columns) => (
  <tr>
    {columns.map((col, idx) =>
      col.children ? (
        <StyledTh
          key={idx}
          colSpan={col.children.length}
          style={{
            width: col.width,
            textAlign: 'center'
          }}
        >
          {col.title}
        </StyledTh>
      ) : (
        <StyledTh
          key={idx}
          colSpan={1}
          rowSpan={2}
          left={col.left}
          style={{ width: col.width }}
        >
          {col.title}
        </StyledTh>
      )
    )}
  </tr>
)

const renderChildColumns = (columns) => {
  const childCols = columns
    .filter((col) => col.children)
    .map((col) => col.children)
    .flat()

  if (childCols.length === 0) return null

  return (
    <tr>
      {columns.map((col) =>
        col.children
          ? col.children.map((child) => (
              <StyledThChild
                key={child.field || child.title}
                style={{ width: child.width }}
              >
                {child.title}
              </StyledThChild>
            ))
          : null
      )}
    </tr>
  )
}

const flattenColumns = (columns) =>
  columns
    .map((col) =>
      col.children
        ? col.children.map((child) => ({ ...child, parentTitle: col.title }))
        : col
    )
    .flat()

const CustomGrid = ({ columns, data, height, loading }) => {
  const hasChildren = columns.some((col) => col.children)
  const flatColumns = flattenColumns(columns)

  return (
    <GridWrapper height={height}>
      <GridInnerWrapper>
        <StyledTable>
          <StyledThead>
            {renderColumns(columns)}
            {hasChildren && renderChildColumns(columns)}
          </StyledThead>
          <tbody>
            {data.length === 0 && !loading ? (
              <tr>
                <StyledTdEmptyData colSpan={flatColumns.length}>
                  Data not found
                </StyledTdEmptyData>
              </tr>
            ) : (
              data.map((row, i) => (
                <StyledTr key={i} index={i}>
                  {flatColumns.map((col) => renderCell(col, row, i))}
                </StyledTr>
              ))
            )}
          </tbody>
        </StyledTable>
      </GridInnerWrapper>
        {loading && <LoadingOverlay>Loading...</LoadingOverlay>}
    </GridWrapper>
  )
}

export default CustomGrid
